import axios from 'axios'
import { BUSCAR_CONFIGURACAO_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarConfiguracaoEmpresa(empresaId) {
    const url = `${URL}/empresas/${empresaId}/configuracao`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_CONFIGURACAO_EMPRESA,
            payload: response
        })
    );
}
